import { Pagamento } from '../../models/Pagamento'

export const ATUALIZA_PAGAMENTO = 'ATUALIZA_PAGAMENTO'

export type PlanoAction = {
  type: typeof ATUALIZA_PAGAMENTO
  payload: Pagamento
}
